module.exports = __webpack_public_path__ + "img/116_planet.2b5a1d12.jpg";